import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import AWS from "aws-sdk";
import { Link } from "react-router-dom";
//actions
import { actions } from "actions/resources";
//components
import { Button, Col, Row } from "antd";

AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_KEY,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
  region: "us-east-1"
});

export class ChallengeQuestionnaireInfo extends Component {
  state = {
    companyName: null
  };

  componentWillMount() {
    const { match } = this.props;
    if (match.params.id) {
      this._fetchDependencies();
    }
  }

  _fetchDependencies = async () => {
    const { fetchChallenge } = this.props;
    await fetchChallenge(this.props.match.params.id);
  };

  render() {
    const { challenge } = this.props;
    if (challenge) {
      return (
        <div className="detail-spacer">
          <div id="challenge-questionnaire-header">
            <Row>
              <Col span={18}>
                <h1 style={{ fontSize: "40px", fontWeight: "bold" }}>
                  Challenge questionnaire
                </h1>
              </Col>
              <Col span={6}>
                <Row type="flex" justify="end">
                  <Link to={`/challenges/edit/${challenge.id}`}>
                    <Button type="primary"> Back </Button>
                  </Link>
                </Row>
              </Col>
            </Row>
            <Row>
              <p
                style={{
                  fontSize: "15px",
                  fontWeight: "bold",
                  color: "grey"
                }}
              >
                Submitted on {moment(challenge.created_at).format("MM/DD/YYYY")}
              </p>
            </Row>
          </div>

          <Row className="challenge-questionnaire">
            <Row className="challenge-questions">
              What are the goals for this challenge?
            </Row>
            <Row className="challenge-answers">
              {challenge.challenge_intent.map((intent, i) => {
                return (
                  <p key={i}>
                    {intent === "other"
                      ? challenge.challenge_intent_other
                      : intent}
                  </p>
                );
              })}
            </Row>
          </Row>
          <Row className="challenge-questionnaire">
            <Row className="challenge-questions">
              What are the relevant business functions for your Challenge?
            </Row>
            <Row className="challenge-answers">
              {challenge.skills.map((skill, i) => {
                return (
                  <span key={i}>
                    {skill === "other" ? challenge.skills_other : skill} ,
                  </span>
                );
              })}
              {challenge.skills_other_links ? (
                <Row>
                  <p
                    style={{
                      fontSize: "15px",
                      fontWeight: "bold",
                      color: "grey",
                      padding: "10px 0px"
                    }}
                  >
                    {challenge.skills_other_links}
                  </p>
                </Row>
              ) : null}
            </Row>
          </Row>
          <Row className="challenge-questionnaire">
            <Row className="challenge-questions">
              When would you like to receive Challenge results and identify
              qualified candidates?
            </Row>
            <Row className="challenge-answers">
              {challenge.results_date
                ? moment(challenge.results_date).format("MM/DD/YYYY")
                : "Open"}
            </Row>
          </Row>
          <Row className="challenge-questionnaire">
            <Row className="challenge-questions">
              How many qualified candidates would you like to source for your
              pipeline or req?
            </Row>
            <Row className="challenge-answers">
              {JSON.parse(challenge.number_of_positions_hiring).map(
                (position, i) => {
                  return <p key={i}>{position}</p>;
                }
              )}
            </Row>
          </Row>
        </div>
      );
    }
    return null;
  }
}

export default connect(
  state => ({ challenge: state.resources.detail.challenge }),
  dispatch => ({
    fetchChallenge: bindActionCreators(actions.fetchChallenge, dispatch)
  })
)(ChallengeQuestionnaireInfo);



// WEBPACK FOOTER //
// ./src/components/dashboard/challenge/questionnaire-info.js